import { fetchWrapper } from '@fukuri-admins/apis/fetchWrapper';
import { REQUEST_API_URL } from '@fukuri-admins/constants/common';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';

type FetchOptions = Parameters<typeof fetchWrapper>[1];

export const clientFetch = async (
  endpoint: string,
  options: FetchOptions,
  onUnauthorized?: () => void
): Promise<Response> =>
  fetchWrapper(
    `${REQUEST_API_URL}/${getThreeLetterCode()}/client_admins${endpoint}`,
    options,
    onUnauthorized
  );
